const MAX_OVAL_ASPECT = 0.78;
const MAX_OVAL_HEIGHT_RATIO = 0.78;
const MAX_OVAL_WIDTH_RATIO = 0.88;

function getMaxOvalSize(width: number, height: number) {
  const ovalHeight = Math.min(
    height * MAX_OVAL_HEIGHT_RATIO,
    (width * MAX_OVAL_WIDTH_RATIO) / MAX_OVAL_ASPECT,
  );
  return {width: ovalHeight * MAX_OVAL_ASPECT, height: ovalHeight};
}

export {getMaxOvalSize};
